import {
  LINKED_ACCOUNT_ANALYZING_MESSAGING_LIMIT_SECONDS,
  LINKED_ACCOUNT_PROCESSING_LIMIT_SECONDS,
} from 'features/advance/constants/constants';

const PLAID_LOADING_EMPTY_MESSAGE = ' ';
export const getPlaidLoadingMessage = ({
  counter,
  translatedText,
}: {
  counter: number | null;
  translatedText: (key: string) => string;
}): string => {
  if (counter === null) {
    return PLAID_LOADING_EMPTY_MESSAGE;
  }

  if (counter > LINKED_ACCOUNT_PROCESSING_LIMIT_SECONDS) {
    return translatedText('loadingScreen.processing');
  }

  if (
    counter <= LINKED_ACCOUNT_PROCESSING_LIMIT_SECONDS &&
    counter > LINKED_ACCOUNT_ANALYZING_MESSAGING_LIMIT_SECONDS
  ) {
    return translatedText('loadingScreen.analyzing');
  }
  return translatedText('loadingScreen.finalizing');
};
